import { MOBILE_PATH_PREFIX } from '@query/constants'

/** Get mobile aware path. @param {string} path -
 * The original path to which the mobile is applied.
 * Can start with or without a leading slash. */
export const getMobileAwarePath = (path: string, isEmbedded: boolean): string => {
  if (!isEmbedded) {
    return path
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const suffix = normalizedPath === '/' ? '' : normalizedPath

  return `${MOBILE_PATH_PREFIX}${suffix}`
}
